import _classCallCheck from "/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import AbstractMatrix from '../abstractMatrix';
import Matrix from '../matrix';

var WrapperMatrix1D = /*#__PURE__*/function (_AbstractMatrix) {
  _inherits(WrapperMatrix1D, _AbstractMatrix);

  /**
   * @class WrapperMatrix1D
   * @param {Array<number>} data
   * @param {object} [options]
   * @param {object} [options.rows = 1]
   */
  function WrapperMatrix1D(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WrapperMatrix1D);

    var _options$rows = options.rows,
        rows = _options$rows === void 0 ? 1 : _options$rows;

    if (data.length % rows !== 0) {
      throw new Error('the data length is not divisible by the number of rows');
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WrapperMatrix1D).call(this));
    _this.rows = rows;
    _this.columns = data.length / rows;
    _this.data = data;
    return _this;
  }

  _createClass(WrapperMatrix1D, [{
    key: "set",
    value: function set(rowIndex, columnIndex, value) {
      var index = this._calculateIndex(rowIndex, columnIndex);

      this.data[index] = value;
      return this;
    }
  }, {
    key: "get",
    value: function get(rowIndex, columnIndex) {
      var index = this._calculateIndex(rowIndex, columnIndex);

      return this.data[index];
    }
  }, {
    key: "_calculateIndex",
    value: function _calculateIndex(row, column) {
      return row * this.columns + column;
    }
  }], [{
    key: Symbol.species,
    get: function get() {
      return Matrix;
    }
  }]);

  return WrapperMatrix1D;
}(AbstractMatrix());

export { WrapperMatrix1D as default };